import React, {lazy, Suspense} from 'react'

const CoursePageLazy = lazy(() =>
    import('./CoursePage')
)

const CoursePage = props => (
    <Suspense fallback={null}>
        <CoursePageLazy {...props} />
    </Suspense>
)

export default CoursePage
